import { put, select, takeLatest, all } from "redux-saga/effects";
import { getActiveCancellationCases } from "../../../api/contract";
import { GET_ACTIVE_CANCELLATION_CASE_LIST } from "../../actions/contract/myContractDetailsActions";
import * as Actions from "../../actions/contract/myContractDetailsActions";
import { pendoTrack } from "../../../util/pendoUtil";

function* getOpenCancellationCases() {
  let accountData = yield select((state) => state.ACCOUNT);
  try {
    yield put(Actions.isLoader(true));
    let accountstate = yield select((state) => state.ACCOUNT);
    let requestBody = {
      accountNo: accountstate.accountNumber,
      regionId: accountstate.regionId,
    };
    const response = yield getActiveCancellationCases(requestBody);
    if (response.data.data.length > 0) {
      yield put(Actions.activeCancellationCaseList(response.data.data));
      yield put(Actions.isActiveCancellationSuccess(true));
      yield put(Actions.isActiveCancellationError(false));
      yield put(Actions.isDuplicateRequest(true));
    } else if (response.data.data.length === 0) {
      yield put(Actions.isActiveCancellationSuccess(true));
    }
    pendoTrack("Customer Portal | Contracts And Services | Edit Services | Active Cancellation Cases | Success", {
      status: "Success",
      statusCode: response.data.statusCode,
      accountId: accountData.accountNumber,
    });
  } catch (error) {
    console.log("active cancellation cases error-> ", error);
    yield put(Actions.isActiveCancellationError(true));
    pendoTrack("Customer Portal | Contracts And Services | Edit Services | Active Cancellation Cases | Failed ", {
      status: "Unable to load data for active cancellation cases",
      statusCode: error.response.data.statusCode,
      accountId: accountData.accountNumber,
    });
  }
  yield put(Actions.isLoader(false));
}

export default function* contractWatcher() {
  yield all([takeLatest(GET_ACTIVE_CANCELLATION_CASE_LIST, getOpenCancellationCases)]);
}
